import Record from './base'

export class Itemimage extends Record {
  constructor(...props) {
    super(...props)
    const data = props[1]
    var lossy = 'fl_lossy,f_auto'
    var thumbnail = 'w_150,h_150,c_thumb,g_auto'
    var square = 'w_360,h_360,c_fill,g_auto'
    var squareFull = 'w_570,h_570,c_fill,g_auto'
    if (!data.image_crop) {
      data.image_crop = `${lossy},d_eg_placeholder_xhn1xm.png`
    } else {
      data.image_crop += `,${lossy},d_eg_placeholder_xhn1xm.png`
    }

    if (!data.image_version) {
      data.image_version = ''
    }

    this.url = encodeURI(
      `//res.cloudinary.com/bidr/image/upload/${data.image_crop}/${
        data.image_version
      }/${data.isMarketplaceItem ? 'marketplace' : data.auctionCode}/${
        data.original_image_name
      }`
    )

    this.fullSizeUrl = encodeURI(
      `//res.cloudinary.com/bidr/image/upload/${lossy},d_eg_placeholder_xhn1xm.png/${
        data.image_version
      }/${data.isMarketplaceItem ? 'marketplace' : data.auctionCode}/${
        data.original_image_name
      }`
    )

    this.thumb_url = encodeURI(
      `//res.cloudinary.com/bidr/image/upload/${thumbnail},${lossy},d_eg_placeholder_xhn1xm.png/${
        data.image_version
      }/${data.isMarketplaceItem ? 'marketplace' : data.auctionCode}/${
        data.original_image_name
      }`
    )

    this.square_url = encodeURI(
      `//res.cloudinary.com/bidr/image/upload/${square},${lossy},d_eg_placeholder_xhn1xm.png/${
        data.image_version
      }/${data.isMarketplaceItem ? 'marketplace' : data.auctionCode}/${
        data.original_image_name
      }`
    )

    this.square_full_url = encodeURI(
      `//res.cloudinary.com/bidr/image/upload/${squareFull},${lossy},d_eg_placeholder_xhn1xm.png/${
        data.image_version
      }/${data.isMarketplaceItem ? 'marketplace' : data.auctionCode}/${
        data.original_image_name
      }`
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/itemimage.js